import axios from "axios";
import router from "@/router";
import qs from "qs";
import { getToken, removeToken } from "@/utils/auth";
import { Notification, MessageBox, Message } from "element-ui";
import store from "@/store/index";
import whiteList from "./whiteList";
const http = axios.create({
  //baseURL:"/admin/api/texin/v1",
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  }
});

// 添加请求拦截器，在请求头中加token
http.interceptors.request.use(
  config => {
    let url1 = "get-policy-info-by-id";
    let url2 = "get-notice-by-id";
    let url3 = "get-apply-public-by-id";
    let url4 = "get-service-sub-type-list";
    let url5 = "list";
    let url6 = "get-by-id";
    let url7 = "get-average-level";
    var newUrl = config.url.split("/");
    if (
      newUrl.indexOf(url1) !== -1 ||
      newUrl.indexOf(url2) !== -1 ||
      newUrl.indexOf(url3) !== -1 ||
      newUrl.indexOf(url4) !== -1 ||
      newUrl.indexOf(url5) !== -1 ||
      newUrl.indexOf(url6) !== -1 ||
      newUrl.indexOf(url7) !== -1
    ) {
    } else {
      if (whiteList.indexOf(config.url) !== -1) {
      } else {
        const isToken = (config.headers || {}).isToken === false;
        if (getToken() && !isToken && getToken() != "undefined") {
          config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
        }
      }
    }
    // if (config.url == item) {
    //     var newUrl = config.url.split('/')
    // }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截
http.interceptors.response.use(response => {
  if (response.data && response.data.code === 401) {
    // 401, token失效
    // removeToken()
    // router.push({ name: 'login' })
    MessageBox.alert("登录状态已过期或在其他地方登录，请重新登录", "系统提示", {
      confirmButtonText: "重新登录",
      // cancelButtonText: '取消',
      showCancelButton: false,
      type: "warning"
    }).then(() => {
      store.dispatch("LogOut").then(() => {
        // location.href = '/cxq/#/index'
        let hrefUrl =
          process.env.NODE_ENV == "production" ? "/cxq/#/index" : "/";
        location.href = hrefUrl;
        sessionStorage.removeItem("userInfo");
        sessionStorage.removeItem("checkDue");
      });
    });
  }
  return response;
});
/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = actionName => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  // "http://development.gtrung.com:7001"

  return (
    (process.env.NODE_ENV !== "production" && process.env.OPEN_PROXY
      ? "/proxyApi/"
      : process.env.NODE_ENV_TOW) + actionName
  );
};
/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    t: new Date().getTime()
  };
  return openDefultParams ? merge(defaults, params) : params;
};

http.adornData = (data = {}, openDefultdata = true, contentType = "json") => {
  var defaults = {
    t: new Date().getTime()
  };
  data = openDefultdata ? merge(defaults, data) : data;
  return contentType === "json" ? JSON.stringify(data) : qs.stringify(data);
};

export default http;



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js